import React, { useState } from 'react';

import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

import ConfirmationDialog from './ConfirmationDialog';

type Props = {
  buttonIcon?: JsxNode;
  buttonText: string;
  title: string;
  description: string;
  loading: boolean;
  confirmButtonLabel?: string;
  onSubmit: () => Promise<void>;
};

export default function DestructiveActionMenuItem({
  buttonIcon,
  buttonText,
  description,
  loading,
  title,
  onSubmit,
  confirmButtonLabel,
}: Props) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const renderIcon = () => {
    if (!buttonIcon) {
      return null;
    }
    return <ListItemIcon>{buttonIcon}</ListItemIcon>;
  };

  return (
    <>
      <MenuItem disabled={loading} onClick={handleOpen}>
        {renderIcon()}
        <ListItemText>{buttonText}</ListItemText>
      </MenuItem>
      <ConfirmationDialog
        title={title}
        description={description}
        loading={loading}
        open={open}
        handleClose={handleClose}
        onSubmit={onSubmit}
        confirmButtonLabel={confirmButtonLabel}
      />
    </>
  );
}
